import 'jquery';

$(window).on('load', function () {
  $('.btn').each( function() {
    $(this).prepend('<div class="btn__arrow"></div>');
  });

  if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) {
    $('.btn__arrow').each( function() {
      $(this).addClass('btn--safari');
    })
  }
});
